import { jsPDF } from "jspdf";
import { brl } from "@/lib/format";
import { addPdfLogo } from "@/lib/useLogo";

const ascii = (s) => String(s ?? "").normalize("NFD").replace(/[\u0300-\u036f]/g, "");
const fmtDate = (iso) => (iso ? iso.split("-").reverse().join("/") : "-");

const drawReceipt = (doc, r, year, parcela, logo) => {
  addPdfLogo(doc, logo, { right: 50, top: 18 });
  const W = doc.internal.pageSize.getWidth();
  const H = doc.internal.pageSize.getHeight();
  const M = 50;
  let y = 60;
  const line = (label, value, { bold = false, size = 10 } = {}) => {
    doc.setFont("helvetica", bold ? "bold" : "normal"); doc.setFontSize(size); doc.setTextColor(30, 30, 30);
    doc.text(ascii(label), M, y);
    if (value != null) doc.text(ascii(value), W - M, y, { align: "right" });
    y += size + 8;
  };
  doc.setFont("helvetica", "bold"); doc.setFontSize(15); doc.setTextColor(20, 20, 20);
  doc.text(ascii(`Recibo do 13o salario - ${parcela}a parcela ${year}`), M, y); y += 18;
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(110, 110, 110);
  doc.text("Central do Courier", M, y); y += 26;
  doc.setDrawColor(200); doc.line(M, y, W - M, y); y += 22;
  line("Colaborador", r.name, { bold: true, size: 11 });
  line("Categoria", r.category);
  line("Data de admissao", fmtDate(r.admission));
  line("Base de calculo (proventos mensais)", brl(r.salary));
  line("Meses trabalhados no ano", `${r.months}/12`);
  y += 6; doc.line(M, y, W - M, y); y += 20;
  line("13o salario integral proporcional", brl(r.gross));
  if (parcela === 1) {
    line("1a parcela (50%)", brl(r.gross / 2));
  } else {
    line("(-) 1a parcela ja paga", `-${brl(r.first_paid)}`);
    line("(-) INSS", `-${brl(r.inss)}`);
  }
  line("(-) Outros descontos", `-${brl(Number(r.other) || 0)}`);
  y += 6; doc.line(M, y, W - M, y); y += 22;
  line("VALOR LIQUIDO A RECEBER", brl(r.net), { bold: true, size: 13 });
  y = Math.max(y + 40, H - 200);
  doc.setFont("helvetica", "normal"); doc.setFontSize(9); doc.setTextColor(70, 70, 70);
  doc.text(doc.splitTextToSize(ascii(`Declaro que recebi a importancia liquida de ${brl(r.net)} referente a ${parcela}a parcela do 13o salario de ${year}, conforme discriminado acima.`), W - 2 * M), M, y);
  y += 70;
  doc.setDrawColor(120);
  doc.line(M, y, M + 300, y);
  doc.line(W - M - 160, y, W - M, y);
  doc.setFontSize(8); doc.setTextColor(110, 110, 110);
  doc.text(ascii(`Assinatura do colaborador - ${r.name}`), M, y + 12);
  doc.text("/          /", W - M - 105, y - 4);
  doc.text("Data do recebimento", W - M - 160, y + 12);
  doc.setTextColor(150, 150, 150);
  doc.text(`Gerado em ${new Date().toLocaleString("pt-BR")}`, M, H - 25);
};

export const buildThirteenthReceipts = (rows, year, parcela, logo) => {
  const doc = new jsPDF({ unit: "pt", format: "a4" });
  rows.forEach((r, i) => { if (i) doc.addPage(); drawReceipt(doc, r, year, parcela, logo); });
  return doc;
};

export const receiptFileName = (name, year, parcela) =>
  `recibo-13-${parcela}a-${year}-${ascii(name || "colaborador").replace(/\s+/g, "-").toLowerCase()}.pdf`;
